import React, { useState } from "react";
import { Link } from "react-router-dom";
import CallSharpIcon from "@mui/icons-material/CallSharp";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import logo from "./biofanalogo.png";
import "./Header2.css";

const Header2 = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      {/* Top Green Bar */}
      <div className="top-bar">Welcome to Biofana foods</div>

      {/* Header */}
      <header className="header-container">
        {/* Logo */}
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="Logo" className="logo-img" />
          </Link>
        </div>

        {/* Navigation Links (Desktop) */}
        <nav className={`nav-links ${isOpen ? "open" : ""}`}>
          <Link to="/">Home</Link>
          <Link to="/categories">Categories</Link>
          <Link to="/featuredproducts">Products</Link>
          <Link to="/ResourcesPage">Resources</Link>
          <Link to="/AboutSection">About us</Link>
        </nav>

        {/* Right Side (Menu Button for Mobile) */}
        <button className="menu-btn" onClick={toggleMenu}>
          {isOpen ? <CloseIcon /> : <MenuIcon />}
        </button>

        {/* Mobile Dropdown */}
        {isOpen && (
          <div className="mobile-menu">
            <div className="mobile-call">
              <a href="tel:+919876543210">
                <CallSharpIcon className="call-icon" /> Call Us
              </a>
            </div>
            <Link to="/" onClick={toggleMenu}>Home</Link>
            <Link to="/categories" onClick={toggleMenu}>Categories</Link>
            <Link to="/featuredproducts" onClick={toggleMenu}>Products</Link>
            <Link to="/ResourcesPage" onClick={toggleMenu}>Resources</Link>
            
            <Link to="/AboutSection" onClick={toggleMenu}>About us</Link>
          </div>
        )}
      </header>
    </>
  );
};

export default Header2;
